/* eslint-disable jsx-a11y/anchor-is-valid */
import ImagesUrl from "#constants/images.js";
import { useLanguageContext } from "#contexts/languageContext.jsx";
import { languageDropdown } from "#utils/seeds.js";
import React, { useContext, useState } from "react";
import BreadCrumb from "./BreadCrumb";
import { useTranslation } from "react-i18next";
import CustomAlert from "./CustomAlert copy";
import AlertTost from "./AlertToast";
import { AuthContext } from "#contexts/authContext.jsx";
import { useNavigate } from "react-router-dom";
import { AdminRoutePath } from "#routes/routePath.jsx";
import { useSideBarContext } from "#contexts/sidebarContext.jsx";
import useGet from "#hooks/useGet.js";
import ENDPOINTS from "#services/endPoints.js";
import QUERY_KEYS from "#services/queryKeys.js";

const Header = ({ header }) => {
  const [active, setActive] = useState(false);
  const { logout } = useContext(AuthContext);
  const { toggleSidebar } = useSideBarContext();
  const nav = useNavigate();
  const { data: profileData } = useGet(
    ENDPOINTS.GET_PROFILE,
    QUERY_KEYS.GET_PROFILE_QUERY_KEY
  );
  const currentLanguage = localStorage?.getItem("language") || "en";
  const { changeLanguage } = useLanguageContext();
  const { t } = useTranslation();

  const handleLanguageChange = (item) => {
    changeLanguage(item.lngValue);
    setActive(false);
  };
  const handleLogout = () => {
    CustomAlert({
      title: " Are you sure you  want to  logout?",
      confirmButtonText: "Confirm",
      icon: "question",
      onConfirm: async () => {
        logout();
        AlertTost("Logout Successfully", "success");
      },
    });
  };

  return (
    <header>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="header_wrapper">
              <div className="header_logo_blk d-flex justify-content-start align-items-center">
                <button
                  className={
                    window.innerWidth <= 992 ? "btn-box" : " btn-box d-none"
                  }
                  onClick={toggleSidebar}
                >
                  <span className="btn_bar btn_width top" />
                  <span className="btn_bar" />
                  <span className="btn_bar btn_width bottom" />
                </button>
                <BreadCrumb />
              </div>
              <div className="header_navbar-wrapper d-flex justify-content-end align-items-center">
                {/* <div className="change-lng-select">
                  <button
                    onClick={() => setActive(!active)}
                    className="lang-btn"
                  >
                    {localStorage?.getItem("language") || "en"}
                    {!active ? (
                      <svg
                        width={18}
                        height={18}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 64 64"
                        id="arrow"
                      >
                        <path
                          d="m-218.7-308.6 2-2 11.7 11.8 11.7-11.8 2 2-13.7 13.7-13.7-13.7"
                          fill="white"
                          stroke="white"
                          transform="translate(237 335)"
                        ></path>
                      </svg>
                    ) : (
                      <svg
                        width={18}
                        height={18}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 64 64"
                        id="arrow"
                      >
                        <path
                          d="m-191.3-296.9-2 2-11.7-11.7-11.7 11.7-2-2 13.7-13.7 13.7 13.7"
                          fill="white"
                          stroke="white"
                          transform="translate(237 335)"
                        ></path>
                      </svg>
                    )}
                  </button>
                  <div
                    style={{ top: "calc(100% + -5px)", zIndex: 1 }}
                    className={`lang-list-blk ${active ? "lang-drop" : ""}`}
                  >
                    {languageDropdown?.map((item, index) => {
                      return (
                        <div key={index} className="lang-item">
                          <button
                            onClick={() => handleLanguageChange(item)}
                            className={`language-btn lang-en ${
                              item.lngValue == currentLanguage ? "active" : ""
                            }`}
                          >
                            {item.name}
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div> */}
                <div className="navbar_prof-wrapper d-flex justify-content-end align-items-center">
                  {/* <div className="header_notification-blk">
                    <button className="header_notification-btn ">
                      <svg
                        width={19}
                        height={21}
                        viewBox="0 0 19 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17.572 14.5996C16.8061 13.6684 15.7575 12.3493 15.7575 11.0034V6.71804C15.7575 3.02664 12.9966 0.0229797 9.46796 0.0229797C5.93865 0.0229797 3.19946 3.02664 3.19946 6.71804V11.0034C3.19946 12.3264 2.06152 13.5765 1.3403 14.5471C0.691271 15.4186 0.178739 16.1077 0.52524 16.7961C0.829083 17.4018 1.59099 17.4792 2.22033 17.4792H5.98065C5.98196 19.4112 7.54843 20.9777 9.48043 20.9777C11.4124 20.9777 12.9802 19.4119 12.9809 17.4792H16.8291C17.2294 17.4792 18.1652 17.4792 18.4875 16.798C18.8123 16.109 18.2926 15.4757 17.572 14.5996ZM9.47977 19.6029C8.3064 19.6029 7.35418 18.6526 7.35287 17.4799H11.6067C11.6047 18.6526 10.6538 19.6029 9.47977 19.6029ZM16.8291 16.0821H2.21968C2.11927 16.0821 2.03527 16.0788 1.96636 16.0742C2.10155 15.8649 2.29974 15.5971 2.46183 15.3799C3.26115 14.3056 4.59793 12.7884 4.59793 11.0034V6.71804C4.59793 3.79642 6.71105 1.42014 9.46927 1.42014C12.2275 1.42014 14.3616 3.79707 14.3616 6.71804V11.0034C14.3616 12.8494 15.5941 14.3922 16.4938 15.4869C16.6454 15.6713 16.8265 15.8918 16.9676 16.0808C16.9256 16.0821 16.8796 16.0827 16.8304 16.0827L16.8291 16.0821Z"
                          fill="black"
                        />
                      </svg>
                    </button>
                  </div> */}
                  <div className="header_profile-blk position-relative">
                    <button
                      type="button"
                      className="header_profile-btn dropdown-toggle"
                      data-bs-toggle="dropdown"
                      data-bs-display="static"
                      aria-expanded="false"
                    >
                      <span className="header_user_profile">
                        <img
                          src={
                            profileData?.data?.image
                              ? profileData?.data?.image
                              : ImagesUrl.noProfile
                          }
                          alt="Profile"
                        />
                      </span>
                      <span className="d-none d-sm-flex flex-column align-items-start">
                        {`Hi, ${profileData?.data?.name}`}
                        <span className="user_role">{t("Administrator")}</span>
                      </span>
                    </button>
                    <ul className="dropdown-menu dropdown-menu-end dropdown-menu-sm-end">
                      <li>
                        <a
                          className="dropdown-item text-capitalize"
                          onClick={() => nav(AdminRoutePath.PROFILE.path)}
                        >
                          <span className="dropdown_item-icon">
                            <svg
                              width={16}
                              height={18}
                              viewBox="0 0 16 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8.00013 9.62499C5.35846 9.62499 3.20846 7.47499 3.20846 4.83332C3.20846 2.19166 5.35846 0.0416565 8.00013 0.0416565C10.6418 0.0416565 12.7918 2.19166 12.7918 4.83332C12.7918 7.47499 10.6418 9.62499 8.00013 9.62499ZM8.00013 1.29166C6.05013 1.29166 4.45846 2.88332 4.45846 4.83332C4.45846 6.78332 6.05013 8.37499 8.00013 8.37499C9.95013 8.37499 11.5418 6.78332 11.5418 4.83332C11.5418 2.88332 9.95013 1.29166 8.00013 1.29166ZM15.1585 17.9583C14.8168 17.9583 14.5335 17.675 14.5335 17.3333C14.5335 14.4583 11.6001 12.125 8.00013 12.125C4.40013 12.125 1.4668 14.4583 1.4668 17.3333C1.4668 17.675 1.18346 17.9583 0.841797 17.9583C0.50013 17.9583 0.216797 17.675 0.216797 17.3333C0.216797 13.775 3.70846 10.875 8.00013 10.875C12.2918 10.875 15.7835 13.775 15.7835 17.3333C15.7835 17.675 15.5001 17.9583 15.1585 17.9583Z"
                                fill="black"
                              />
                            </svg>
                          </span>
                          <span>{t("My Profile")}</span>
                        </a>
                      </li>
                      <li className="lock_icon">
                        <a
                          className="dropdown-item text-capitalize"
                          onClick={() =>
                            nav(AdminRoutePath.CHANGE_PASSWORD.path)
                          }
                        >
                          <span className="dropdown_item-icon">
                            <svg
                              width={20}
                              height={20}
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M4 6.66658V5.33325C4 3.12659 4.66667 1.33325 8 1.33325C11.3333 1.33325 12 3.12659 12 5.33325V6.66658"
                                stroke="#10140B"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M8.00016 12.3333C8.92064 12.3333 9.66683 11.5871 9.66683 10.6667C9.66683 9.74619 8.92064 9 8.00016 9C7.07969 9 6.3335 9.74619 6.3335 10.6667C6.3335 11.5871 7.07969 12.3333 8.00016 12.3333Z"
                                stroke="#10140B"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M11.3335 14.6667H4.66683C2.00016 14.6667 1.3335 14.0001 1.3335 11.3334V10.0001C1.3335 7.33341 2.00016 6.66675 4.66683 6.66675H11.3335C14.0002 6.66675 14.6668 7.33341 14.6668 10.0001V11.3334C14.6668 14.0001 14.0002 14.6667 11.3335 14.6667Z"
                                stroke="#10140B"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </span>
                          <span>{t("Change Password")}</span>
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item text-capitalize"
                          onClick={() => handleLogout()}
                        >
                          <span className="dropdown_item-icon">
                            <svg
                              width={20}
                              height={20}
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M19.3735 9.37536H11.457C11.112 9.37536 10.832 9.09537 10.832 8.75038C10.832 8.40539 11.112 8.1254 11.457 8.1254H19.3735C19.7185 8.1254 19.9985 8.40539 19.9985 8.75038C19.9985 9.09537 19.7185 9.37536 19.3735 9.37536Z"
                                fill="black"
                              />
                              <path
                                d="M16.2495 12.5004C16.1674 12.5006 16.0861 12.4845 16.0103 12.453C15.9344 12.4215 15.8656 12.3753 15.8077 12.3171C15.5636 12.0728 15.5636 11.677 15.8077 11.4329L18.4911 8.74971L15.8077 6.06639C15.5636 5.82226 15.5636 5.42645 15.8077 5.18232C16.052 4.93803 16.4478 4.93803 16.692 5.18232L19.8169 8.30722C20.061 8.55136 20.061 8.94716 19.8169 9.1913L16.692 12.3162C16.6341 12.3747 16.5652 12.4211 16.4892 12.4527C16.4133 12.4843 16.3318 12.5005 16.2495 12.5004ZM6.66651 20.0001C6.48816 20.0001 6.31894 19.9751 6.14985 19.9226L1.13493 18.2518C0.452525 18.0135 0 17.3777 0 16.667V1.66743C0 0.748279 0.747516 0.000762939 1.66667 0.000762939C1.84486 0.000762939 2.01412 0.0257622 2.18333 0.0782605L7.1981 1.74907C7.88061 1.98738 8.33302 2.62322 8.33302 3.33394V18.3335C8.33302 19.2526 7.58566 20.0001 6.66651 20.0001ZM1.66667 1.25072C1.43749 1.25072 1.24996 1.43822 1.24996 1.66743V16.667C1.24996 16.8444 1.3691 17.0093 1.53909 17.0686L6.53054 18.7319C6.5664 18.7435 6.61311 18.7502 6.66651 18.7502C6.89568 18.7502 7.08306 18.5626 7.08306 18.3335V3.33394C7.08306 3.15648 6.96392 2.99153 6.79393 2.93235L1.80248 1.26904C1.76662 1.25744 1.71991 1.25072 1.66667 1.25072Z"
                                fill="black"
                              />
                              <path
                                d="M12.7072 6.66715C12.3622 6.66715 12.0822 6.38716 12.0822 6.04217V2.29229C12.0822 1.71809 11.6149 1.2506 11.0407 1.2506H1.666C1.32101 1.2506 1.04102 0.97061 1.04102 0.625621C1.04102 0.280632 1.32101 0.000640869 1.666 0.000640869H11.0407C12.3048 0.000640869 13.3322 1.02815 13.3322 2.29229V6.04217C13.3322 6.38716 13.0522 6.66715 12.7072 6.66715ZM11.0407 17.5001H7.70737C7.36238 17.5001 7.08239 17.2201 7.08239 16.8751C7.08239 16.5301 7.36238 16.2501 7.70737 16.2501H11.0407C11.6149 16.2501 12.0822 15.7826 12.0822 15.2084V11.4586C12.0822 11.1136 12.3622 10.8336 12.7072 10.8336C13.0522 10.8336 13.3322 11.1136 13.3322 11.4586V15.2084C13.3322 16.4726 12.3049 17.5001 11.0407 17.5001Z"
                                fill="black"
                              />
                            </svg>
                          </span>
                          <span>{t("Logout")}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
